// Which monthly plans the public pricing page lists. Shared by Packages.jsx
// and the static-page build (scripts/prerender.mjs), so the prices crawlers
// see are exactly the prices customers see.
//
// Hidden (UI only; existing subscriptions and Stripe are untouched):
// - Rhino Plus $199 and Rhino Pro $299: legacy prices still in the plans table
// - Pause Subscription: an internal plan, not something to buy
// - "... Staging ..." plans: internal test plans
export const isPublicPlan = (plan) => {
  const price = parseInt(plan.price, 10);
  const name = (plan.plan_name || "").toLowerCase().trim();
  const slug = (plan.plan_slug || "").toLowerCase().trim();

  if (plan.plan_slug === "rhino-plus" && price === 199) return false;
  if (plan.plan_slug === "rhino-pro" && price === 299) return false;
  if (
    slug === "pause-subscription" ||
    slug === "pause_subscription" ||
    name.includes("pause subscription")
  ) {
    return false;
  }
  if (name.includes("staging")) return false;
  return true;
};

export const isEnterprisePlan = (plan) => parseInt(plan.is_enterprise, 10) === 1;
